var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFurnishing = function SvgFurnishing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#furnishing_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#6E3037",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M7.763 35.297H4.94v-2.824h3.53zM28.237 35.297h2.824v-2.824h-3.53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCAA1",
    d: "M8.477 26.12h4.221a3.52 3.52 0 0 0 1.417-2.823 3.53 3.53 0 0 0-3.527-3.527c-1.154 0-2.18.556-2.824 1.416v4.221c.202.27.442.511.713.714M28.598 21.781a3.53 3.53 0 0 0-3.184-2.011 3.53 3.53 0 0 0-3.527 3.527c0 1.154.557 2.18 1.416 2.824h4.222c.27-.203.51-.444.713-.714v-2.052c0-.562.13-1.096.36-1.574"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.232,
    cy: 18.352,
    r: 0.703,
    fill: "#6E3037"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.768,
    cy: 23.297,
    r: 0.703,
    fill: "#6E3037"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCAA1",
    d: "m25.404 9.672 6 6.538h-4.588c-.78 0-1.412-.632-1.412-1.412zM5.865 5.363l1.178 5.924H2.115c-.78 0-1.412-.632-1.412-1.411V3.469zM22.53 2.115v2.294h-.012l-6.492 6.878H7.043l7.427-5.1L9.633.704h11.484c.78 0 1.412.632 1.412 1.412M35.298 2.115c0-.78-.632-1.412-1.412-1.412h-4.954l1.226 9.088 5.14 4.596V2.115"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#6E3037",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M22.53 9.875c0 .78-.633 1.412-1.413 1.412H2.115c-.78 0-1.412-.632-1.412-1.412v-7.76c0-.78.632-1.412 1.412-1.412h19.002c.78 0 1.412.632 1.412 1.412zM25.404 2.115c0-.78.632-1.412 1.412-1.412h7.069c.78 0 1.412.632 1.412 1.412v12.682c0 .78-.633 1.412-1.412 1.412h-7.069c-.78 0-1.412-.632-1.412-1.412zM7.764 26.117h20.474M31.707 19.767c-1.936.032-3.47 1.651-3.47 3.587v5.59H7.763V18.412c0-1.935-1.534-3.555-3.47-3.587a3.53 3.53 0 0 0-.766 6.988v9.25c0 .779.632 1.411 1.412 1.411h26.122c.78 0 1.412-.632 1.412-1.412v-4.307a3.531 3.531 0 0 0-.766-6.988"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "furnishing_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h36v36H0z"
  })))));
};
export default SvgFurnishing;